import * as Yup from 'yup';

export const GetInialValues = data => {
  const obj = {
    nome_projeto: data ? data.nome || data.nome_projeto || '' : '',
    idetificacao_projeto: data
      ? data.key || data.idetificacao_projeto || ''
      : '',
    id_centro_de_custo: data ? data.id_centro_de_custo || '' : '',
    date: data ? data.dt_apontamento || '' : '',
    itens: data
      ? data.itens
      : [
          {
            _id: new Date().getTime(),
            id_tipo_reembolso: '',
            id_item_reembolso: '',
            quantidade: '',
            valor_unitario: '',
          },
        ],
    id_aprovacao_gestor: 1,
    id_aprovacao_pagamento: 1,
    detalhamento: data ? data.detalhamento || '' : '',
  };
  return obj;
};

export const FormValidation = Yup.object().shape({
  nome_projeto: Yup.string().required('Digite o nome do projeto'),
  idetificacao_projeto: Yup.string().required(
    'É necessário informar o numero da identificação do projeto',
  ),
  itens: Yup.array()
    .of(
      Yup.object().shape({
        _id: Yup.number().nullable(),
        id_item_reembolso: Yup.number().nullable(),
        id_tipo_reembolso: Yup.number().required('Selecione uma opção válida'),
        quantidade: Yup.number().required(
          'Digite a quantidade consumida, minimo 1',
        ),
        valor_unitario: Yup.number().required('Digite o valor gasto'),
      }),
    )
    .required('Preencha as informações deste item.'),
  id_aprovacao_gestor: Yup.number().nullable(),
  id_aprovacao_pagamento: Yup.number().nullable(),
  id_centro_de_custo: Yup.number().required(
    'Por favor, selecione um centro de custos',
  ),
  date: Yup.string().nullable(),
  detalhamento: Yup.string()
    .required('Descreva o que foi gasto.')
    .min(10, 'É necessário no mínimo 10 caracteres')
    .max(255, 'Máximo de 255 caracteres excedido'),
});
